export default __webpack_public_path__ + "static/media/twitter.41a71efb.svg";